import { View, Text, Flex, Menu, ActionButton, Item, MenuTrigger } from "@adobe/react-spectrum";
import MoreVertical from "@spectrum-icons/workflow/MoreVertical";
import { NoteItem } from "./types";
import MyNotesDefaultPage from "./MyNotesDefaultPage";

export default function NotesList({
  notes,
  selectedId,
  onSelect,
  onDelete,
}: {
  notes: NoteItem[];
  selectedId: string;
  onSelect: (id: string) => void;
  onDelete: (id: string) => void;
}) {

  return (
    <View width="320px" UNSAFE_className="mynotes-list">
      {notes.length === 0 ? (
        <View UNSAFE_className="mynotes-empty-sidebar">
          <Text UNSAFE_style={{ 
            textAlign: "center", 
            color: "#666", 
            fontSize: "14px",
            padding: "20px"
          }}>
            No notes available
          </Text>
        </View>
      ) : (
        notes.map((note) => {
        const isSelected = note.id === selectedId;
        return (
          <div key={note.id} onClick={() => onSelect(note.id)}>
            <View
              UNSAFE_className={`mynotes-list-item ${isSelected ? "selected" : ""
                }`}
            >
              <Flex direction="row" alignItems="center" justifyContent="space-between">
                <Text UNSAFE_className="mynotes-list-title">
                  {note.title}
                </Text>
                <MenuTrigger>
                  <ActionButton
                    UNSAFE_className="mynotes-menu-button"
                    onPress={() => { }}
                    isQuiet={true}
                  >
                    <MoreVertical />
                  </ActionButton>
                  <Menu
                    onAction={(key) => {
                      if (key === 'delete') {
                        onDelete(note.id);
                      }
                    }}
                  >
                    <Item key="delete">
                      Delete
                    </Item>
                  </Menu>
                </MenuTrigger>

              </Flex>
              <Flex direction="row" alignItems="center" UNSAFE_className="mynotes-list-meta">
                <Text UNSAFE_className="mynotes-list-sub meta-text">
                  {note.excerpt}
                </Text>
                <Text UNSAFE_className="mynotes-list-sub time">
                  {note.updatedLabel}
                </Text>
              </Flex>
            </View>
          </div>
        );
      })
      )}
    </View>
  );
}
